// Recalculate these measures from the items actually present in Questions.json.
// Missing required items are unavailable, never a zero or a prorated score.
const questionnaire = require('../components/Questions.json');
const groups = {
  MotivationAtWork: { Intrinsic: 'MAWINTRI', Identified: 'MAWIDENT', Introjected: 'MAWINTRO', ExternalMotivation: 'MAWEXTER' },
  Curiosity: { JoyousExploration: 'CUJE', DeprivationSensitivity: 'CUDS', StressTolerance: 'CUST', ThrillSeeking: 'CUTS', OvertSocial: 'SOCUO', CovertSocial: 'SOCUC' },
};
const rows = [];
function visit(node) {
  if (!node || typeof node !== 'object') return;
  if (node.type === 'matrix') (node.rows || []).forEach(row => rows.push(typeof row === 'string' ? row : row.value));
  ['pages','elements'].forEach(key => (node[key] || []).forEach(visit));
}
visit(questionnaire);
function validAnswer(value) {
  if (typeof value !== 'number' && typeof value !== 'string') return null;
  if (typeof value === 'string' && value.trim() === '') return null;
  const answer = Number(value);
  return Number.isInteger(answer) && answer >= 1 && answer <= 5 ? answer : null;
}
function repairTargetScores(resultSet, raw) {
  resultSet.scoreAvailability = {};
  resultSet.scoringWarnings = [];
  for (const [group, definitions] of Object.entries(groups)) {
    let total = 0, answered = 0, expected = 0;
    for (const [name, prefix] of Object.entries(definitions)) {
      const keys = rows.filter(key => key.startsWith(prefix));
      let sum = 0, count = 0;
      keys.forEach(key => {
        const value = validAnswer(raw[key]);
        if (value !== null) { count++; sum += key.endsWith('r') ? 6 - value : value; }
      });
      const available = keys.length > 0 && count === keys.length;
      resultSet[group][name] = available ? sum : null;
      resultSet.scoreAvailability[group + '.' + name] = { answered: count, expected: keys.length, available, scaleMax: keys.length * 5 };
      total += sum; answered += count; expected += keys.length;
    }
    const available = expected > 0 && answered === expected;
    resultSet[group].Total = available ? total : null;
    // Preserve the existing Motivation average convention of four subscale totals.
    resultSet[group].Average = available ? total / (group === 'MotivationAtWork' ? Object.keys(definitions).length : expected) : null;
    resultSet.scoreAvailability[group + '.Total'] = { answered, expected, available, scaleMax: expected * 5 };
    if (!available) resultSet.scoringWarnings.push({ measure: group, answered, expected, reason: 'Saved answers are incomplete or invalid for the current questionnaire.' });
  }
  return resultSet;
}
function scorePercent(value, max) {
  if ((typeof value !== 'number' && typeof value !== 'string') || String(value).trim() === '') return null;
  const number = Number(value);
  return Number.isFinite(number) && Number.isFinite(Number(max)) && Number(max) > 0 ? number / Number(max) * 100 : null;
}
module.exports = { repairTargetScores, scorePercent };
